import { render, staticRenderFns } from "./ConsentKBC.vue?vue&type=template&id=edf5d2be&"
import script from "./ConsentKBC.vue?vue&type=script&lang=js&"
export * from "./ConsentKBC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports